<template>
  <div class="imprint-edit">
    <div class="location-edit">
      <dl class="imprint-edit__block">
        <dt class="imprint-edit__block-title">
          Select Location
          <span class="more-location-tips" v-show="isShowAddAnother">(You may add additional locations later)</span>
        </dt>
        <dd class="imprint-edit__block-body" ref="imprinteditlocations">
          <button type="button" class="btn-select trans" :class="{
            'is-active': currentLocation?.Name === location.Name,
            'is-selected': isLocationSelected(location.Name) && currentLocation?.Name !== location.Name,
            'is-disabled': !location.Enabled
          }" v-for="(location, index) in locationGroupList" :key="index" @click="onLocationClick(location)"
            @mouseover="onLocationMouse(location)" @mouseout="onLocationMouse()">
            {{ location.Name }}
            <svg v-if="location.Methods[0].LocationHoverImagePath !== null" style="vertical-align: middle;"
              viewBox="0 0 1024 1024" width="15" height="15">
              <path
                d="M866.4576 102.4H157.5424C98.816 102.4 51.2 150.016 51.2 208.7424v567.1424c0 58.7264 47.616 106.3424 106.3424 106.3424h708.9152c58.7264 0 106.3424-47.616 106.3424-106.3424V208.7424C972.8 150.016 925.184 102.4 866.4576 102.4zM157.5424 173.312h708.9152c19.5584 0 35.4304 15.872 35.4304 35.4304v339.5584l-181.4528-181.4528-177.9712 182.8864-108.4416-108.4928-311.9104 320.4608v-552.96c0-19.5584 15.872-35.4304 35.4304-35.4304z m546.56 638.0032H172.4416l262.2976-269.3632 269.3632 269.3632z m197.7856-35.4304c0 19.5584-15.872 35.4304-35.4304 35.4304h-62.3616l-212.6848-212.6848 133.2736-130.4064 180.736 180.736-3.5328 126.9248zM263.8848 385.9456a70.912 70.912 0 1 1 0-141.7728 70.912 70.912 0 0 1 0 141.824z">
              </path>
            </svg>
          </button>
          <img class="imprint-edit__block-location-img" :src="locationHoverImagePath"
            v-if="locationHoverImagePath !== ''" />
          <button type="button" class="btn btn-orange trans btn-remove-item" v-if="selectedList.length > 1"
            v-on:click="onRemoveOrCancel"></button>
        </dd>
      </dl>
      <dl class="imprint-edit__block" v-if="currentLocation">
        <dt class="imprint-edit__block-title">Select Method</dt>
        <dd class="imprint-edit__block-body">
          <button type="button" class="btn-select trans" :class="{
            'is-active': imprintMethodModel.decorationMethod.Method === method.Method,
            'is-disabled': method.Enabled == false
          }" v-for="(method, index) in currentLocation.Methods" :key="index" @click="onMethodClick(method)">
            {{ method.MappedMethod }}
          </button>
        </dd>
        <dd class="imprint-edit__block-body"
          v-if="imprintMethodModel.decorationMethod.IsSupportPersonalization === 1 && appState.getOrderType !== OrderType.SpecSample">
          <div class="imprint-edit__personalize">
            <div class="imprint-edit__personalize-label">
              <input type="checkbox" :id="'needpersonalize'"
                :checked="imprintMethodModel.decorationMethod.isPersonalizationSelected" @click="onPersonalizeClick" />
              <label :for="'needpersonalize'" style="cursor: pointer">I'd like to personalize with variable data such as
                names, numbers, etc.</label>
            </div>
            <div class="imprint-edit__personalize-fee"
              v-show="imprintMethodModel.decorationMethod.isPersonalizationSelected"
              v-html="imprintMethodModel.decorationMethod.PersonalizationDesc"></div>
            <div class="imprint-edit__personalize-notes"
              v-show="imprintMethodModel.decorationMethod.isPersonalizationSelected">
              Please contact our Reps to offer your variable data file
            </div>
          </div>
        </dd>
        <dd class="imprint-edit__block-body imprint-edit__size" v-if="imprintMethodModel.decorationMethod.Size">
          <span>Imprint Size: </span>
          <em>{{ imprintMethodModel.decorationMethod.Size }}</em>
        </dd>
      </dl>
      <div v-if="imprintMethodModel.decorationMethod">
        <dl class="imprint-edit__block" v-if="imprintMethodModel.decorationMethod.DisplayColors.length > 0">
          <dt class="imprint-edit__block-title">Select Colors</dt>
          <dd class="imprint-edit__block-body error-block" :class="{
            'is-error': state.maxColorShow || state.noColorShow
          }">
            <imprint-color :imprint-method-model="imprintMethodModel" @max-color-error="onMaxColorError"
              @click="onColorClick"></imprint-color>
            <div class="error-label" v-show="state.noColorShow">Please, select imprint color.</div>
            <div class="error-label" v-show="state.maxColorShow">
              {{ state.maxColorShow }}
            </div>
            <div class="error-label" v-show="imprintMethodModel.decorationMethod.sameColorError"
              style="padding-top: 3px">
              Attention, imprint color does not contrast well on the item color.
            </div>
          </dd>
        </dl>
        <dl class="imprint-edit__block">
          <dt class="imprint-edit__block-title">Artwork Options</dt>
          <dd class="imprint-edit__block-body error-block" :class="{ 'is-error': notFilesError }">
            <ImprintArtwork :imprint-method-model="imprintMethodModel"
              @share-link-change="onShareLinkChange" @change="onArtworkTypeChange"
              @online-designed="notFilesError = false" @file-change="onLogoFileChange">
            </ImprintArtwork>

            <div class="error-label" v-show="notFilesError">Please upload your logo or select other options.</div>
            <div class="error-label" v-show="shareLinkEmpty">Please enter the link you want to share.</div>
          </dd>
        </dl>
        <dl class="imprint-edit__block">
          <dt class="imprint-edit__block-title">Artwork Instruction</dt>
          <dd class="imprint-edit__block-body">
            <div class="error-block" :class="{ 'is-error': noCustomerNotesError }">
              <rich-text v-model="customerNotes" placeholderText="Please include any imprint instructions."></rich-text>
              <div class="error-label" v-show="noCustomerNotesError">Any design instructions for our artists?</div>
            </div>
          </dd>
        </dl>
      </div>

      <div class="imprint-edit-btns">
        <ap-button type="primary" size="small" @click="onSave(false)">Continue</ap-button>
        <div v-show="isShowAddAnother">
          <span class="imprint-btn__or">or</span>
          <ap-button type="default" size="small" class="btn-add-another" @click="onSave(true)">Add Another
            Location</ap-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, ref, reactive } from 'vue'
import { useWindow } from '../../composables'
import { ApButton } from '@anypromo/components-pc'
import RichText from '@anypromo/components-pc/RichText/RichText.vue'

import { type LocationGroup, type LocationMethod, OrderType } from '../../types'
// import { imprintContextKey } from '../../token'
import { useApp } from '../../store/modules/app'
import { useImprintMethod } from '../../store/modules/imprintMethod'
import { ImprintMethodModel } from '../../model'
import ImprintColor from './imprintColor.vue'
import ImprintArtwork from './imprintArtwork.vue'

interface Props {
  showAddAnotherBtn: boolean,
  currentIndex: number,
  imprintMethodModel: ImprintMethodModel,
}

const props = withDefaults(defineProps<Props>(), {
  showAddAnotherBtn: false,
  currentIndex: -1,
});

const emit = defineEmits(['update:customerNotes', 'update:imprintMethodModel', 'remove', 'save', 'disable-location-click', 'disable-method-click', 'update:persionalize'])


const isShowAddAnother = computed(() => props.showAddAnotherBtn)

const { locationGroupList } = useWindow()

// artwork选择upload时，未上传文件给的提示
const notFilesError = ref(false)
// Design for Me 没有填写Artwork Instruction的错误提示
const noCustomerNotesError = ref(false)

// Share Link 没有填写链接的错误提示
const shareLinkEmpty = ref(false)

// // 当前所选的method
const currentLocation = computed<LocationGroup | undefined>({
  get () {
    return locationGroupList.find((f) => f.Name === props.imprintMethodModel.decorationMethod.Location)
  },
  set (val) {
    // selfCurrentLocation = val as unknown as LocationGroup
  }
})

const customerNotes = computed({
  get: () => props.imprintMethodModel.decorationMethod.customerNotes,
  set: (val) => {
    emit('update:customerNotes', props.currentIndex, val)
    if (props.imprintMethodModel.decorationMethod.artworkType === 3) {
      noCustomerNotesError.value = val.length === 0
    }
  }
})
//
const isPersonalizationSelected = ref(false)
const locationHoverImagePath = ref('')

// 颜色错误

const state = reactive<{
  maxColorShow: string
  noColorShow: boolean
}>({
  maxColorShow: '',
  noColorShow: false,
})

const appState = useApp()
const imprintMethodState = useImprintMethod()

const selectedList = computed(() => imprintMethodState.getSelectedList)

// 判断是否可以选中
const isLocationSelected = computed(
  () => (name: string) =>
    selectedList.value
      .filter((f) => f.objectId !== props.imprintMethodModel.objectId)
      .map((f) => f.decorationMethod.Location)
      .concat([props.imprintMethodModel.decorationMethod.Method])
      .includes(name)
)

const onMaxColorError = (msg: string) => {
  state.maxColorShow = msg
  setTimeout(function () {
    state.maxColorShow = ''
  }, 3000)
}

const onColorClick = () => {
  const { imprintMethodModel } = props
  imprintMethodModel.decorationMethod.sameColorError = false
  state.noColorShow = imprintMethodModel.decorationMethod.selectedColors.length === 0
  if (state.noColorShow) {
    state.maxColorShow = ''
  } else {
    imprintMethodState.checkSameColor()
  }
}

const onLocationMouse = (location?: LocationGroup) => {
  if (location === undefined) {
    locationHoverImagePath.value = ''
  }
  else if (location.Methods[0].LocationHoverImagePath !== null) {
    locationHoverImagePath.value = location.Methods[0].LocationHoverImagePath
  }
  else {
    locationHoverImagePath.value = ''
  }
}

/**
 * location 切换
 * @param location
 */
const onLocationClick = (location: LocationGroup) => {
  const { imprintMethodModel } = props
  if (selectedList.value.filter((f) => f.objectId !== props.imprintMethodModel.objectId)
    .some((f) => f.decorationMethod.Location === location.Name)) {
    return
  }

  if (location.Enabled === false) {
    emit('disable-location-click', location)
    return
  }
  // 切换imprint method

  let validMethods = location.Methods.filter((f) => f.Enabled && f.Method === props.imprintMethodModel.decorationMethod?.Method)
  if (validMethods.length === 0) {
    validMethods = location.Methods.filter((f) => f.Enabled)
  }
  if (validMethods.length > 0) {
    imprintMethodModel.decorationMethod = validMethods[0]
  }
}

const onRemoveOrCancel = () => {
  emit('remove', props.currentIndex)
}

/**
 * Method点击
 * @param method
 */
const onMethodClick = (method: LocationMethod) => {
  const { imprintMethodModel } = props
  if (method.Enabled === false) {
    emit('disable-method-click', currentLocation.value!, method)
    return
  }

  state.noColorShow = false
  notFilesError.value = false
  shareLinkEmpty.value = false
  noCustomerNotesError.value = false
  imprintMethodModel.decorationMethod = method
}

const onArtworkTypeChange = () => {
  notFilesError.value = false
  shareLinkEmpty.value = false
  noCustomerNotesError.value = false
}

const onShareLinkChange = () => {
  const { imprintMethodModel } = props
  if (imprintMethodModel.decorationMethod.shareLink.length > 0) {
    shareLinkEmpty.value = false
  }
}
const onLogoFileChange = () => {
  const { imprintMethodModel } = props
  notFilesError.value = imprintMethodModel.decorationMethod.selectedArtworkFiles.length === 0 && !imprintMethodModel.decorationMethod.virtualDesignImage
}
const onPersonalizeClick = (evt: MouseEvent) => {
  var target = evt.target as HTMLInputElement
  emit('update:persionalize', props.currentIndex, target.checked)
}

const onSave = (isAddAnother: boolean) => {
  if (!currentLocation.value) {
    return
  }

  const { imprintMethodModel } = props

  notFilesError.value = false
  state.noColorShow = false
  noCustomerNotesError.value = false
  shareLinkEmpty.value = false

  if (imprintMethodModel.decorationMethod.MaxColors > 0 && imprintMethodModel.decorationMethod.selectedColors.length === 0) {
    // toast("Please, select imprint color.", 2000);
    state.noColorShow = true
  }
  if (imprintMethodModel.decorationMethod.artworkType === 1) {
    // const isNeedUpLogo = false

    if (imprintMethodModel.decorationMethod.selectedArtworkFiles.length === 0 && !imprintMethodModel.decorationMethod.virtualDesignImage) {
      notFilesError.value = true
    }

  } else if (imprintMethodModel.decorationMethod.artworkType === 3) {
    if (customerNotes.value.length === 0) {
      noCustomerNotesError.value = true
    }
  } else if (imprintMethodModel.decorationMethod.artworkType === 5) {
    if (imprintMethodModel.decorationMethod.shareLink.length === 0) {
      shareLinkEmpty.value = true
    }
  }
  if (state.noColorShow || shareLinkEmpty.value || notFilesError.value || noCustomerNotesError.value) {
    return
  }
  emit('save', props.currentIndex, isAddAnother)
}
</script>

<style lang="less">
.imprint-edit {
  margin-bottom: 10px;
  font: normal 14px/18px;
  position: relative;

  .more-location-tips {
    color: gray;
    font-weight: 400;
  }

  .ap-alert {
    padding: 5px;
    display: inline-flex;
  }

  &__block {
    dl:first-of-type {
      margin-top: 0 !important;
    }

    &-title {
      display: block;
      margin-bottom: 6px;
      font-size: 14px;
    }

    &-body {
      display: block;
      position: relative;
      padding-left: 20px;

      // padding-right: 40px;
      .btn-select {
        margin-right: 5px;
      }

      .btn-select:last-child {
        margin-right: 0;
      }
    }

    &-location-img {
      position: absolute;
      z-index: 999;
    }

    .artwork-option-item {
      font-size: 13px;
    }

    .btn-remove-item {
      display: inline-block;
      position: absolute;
      top: -25px;
      right: 0;
      width: auto;
      height: auto;
      padding: 8px 12px;
      font-size: 14px;
      border-radius: 0;
      color: #fff;
      background: #ff7900;
      border: none;
      font-weight: 500;
      cursor: pointer;
      line-height: 1em;

      &:after {
        content: 'x';
      }
    }
  }

  &__personalize {
    font-size: 13px;

    label {
      font-weight: normal;
      margin-bottom: 2px;
      padding-left: 5px;
      cursor: pointer;

      &:hover {
        color: rgb(205, 77, 8);
      }
    }
  }

  &__personalize-fee {
    margin-left: 18px;
  }

  &__personalize-notes {
    color: #246cb6;
    margin-left: 18px;
    margin-top: 10px;
  }

  &__size {
    margin-top: 5px;

    span {
      color: #999;
    }

    em {
      font-style: normal;
    }
  }
}

.imprint-edit-btns {
  padding: 0;
  margin: 15px 0;
  display: flex;
}
</style>
